import { render } from "./ReportPlanStatsManager.vue?vue&type=template&id=8763c8c8&scoped=true"
import script from "./ReportPlanStatsManager.vue?vue&type=script&lang=js"
export * from "./ReportPlanStatsManager.vue?vue&type=script&lang=js"

import "./ReportPlanStatsManager.vue?vue&type=style&index=0&id=8763c8c8&scoped=true&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8763c8c8"]])

export default __exports__